export const API_KEY = {
  GOOGLE_MAP: 'AIzaSyAQxS-erNv39iCrdl4dB4bvaC5OVm-xb-A',
  GOOGLE_CLIENT_ID:'783347595560-fa9ufjb9qfrhk667h2igc4lhfnsuk31q.apps.googleusercontent.com',
}